import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@ui-propulsion/react-components';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './productDescription.module.scss';
import handleCTAClick from '../../services/helpers/handleCTAClick';
import { ctaTheme } from '../../utils/util';

export default function ProductDescription({
  headline = '',
  description = '',
  cta,
  images = [],
  theme = '',
}) {
  const [ctaThemes, setCtaThemes] = useState(styles.redSolid);

  useEffect(() => {
    setCtaThemes(ctaTheme(cta?.ctaTheme));
  }, [cta]);

  const businessProduct = images.length > 0 && (
    <div className={styles.background}>
      {images?.map((img, i) => {
        const divStyle = {
          backgroundImage: `url(${img?.url})`,
        };
        if (i === 0) {
          return (
            <div
              key={`row-${i}`.toString()}
              className={styles.lcLogo}
              style={divStyle}
            />
          );
        }
        return (
          <React.Fragment key={`row-${i}`.toString()}>
            {' '}
            <div className={styles.plusLogo}>+</div>
            <div className={styles.aofLogo} style={divStyle} />
          </React.Fragment>
        );
      })}
    </div>
  );

  return (
    <div
      className={
        theme === 'darkBlue' ? styles.darkTheme : styles.productDescription
      }
    >
      <Grid container>
        <Grid item xs={12} sm={4}>
          <h2 className={styles.header}>{headline}</h2>
        </Grid>
        <Grid item xs={12} sm={8}>
          {businessProduct}
          <div className={styles.content}>{parse(description)}</div>
        </Grid>

        <Grid item container xs={12} justifyContent="center">
          {cta && (
            <Button
              data-testid="cta-button"
              className={ctaThemes}
              variant="tertiary"
              onClick={(e) => handleCTAClick(e, cta)}
              href={cta.link}
            >
              {cta.label}
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

ProductDescription.propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
    ctaTheme: PropTypes.string,
  }),
  images: PropTypes.array,
  theme: PropTypes.string,
};
